<template>
  <div
    v-if="isMaintenance"
    class="fixed inset-0 z-[99999] flex flex-col items-center justify-center bg-[#090C15] text-white px-4 font-sans overflow-hidden"
  >
    <!-- Background Glow Effects -->
    <div
      class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#1BF3FF]/10 rounded-full blur-[140px] pointer-events-none"
    ></div>
    <div
      class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[350px] h-[350px] bg-[#6B75CA]/15 rounded-full blur-[90px] pointer-events-none"
    ></div>

    <div
      class="relative z-10 flex flex-col items-center text-center max-w-lg p-8 sm:p-10 rounded-3xl bg-white/[0.03] border border-white/10 backdrop-blur-xl shadow-[0_0_50px_rgba(0,0,0,0.5)]"
    >
      <!-- Logo -->
      <img
        src="./assets/cleanswipe-logo.png"
        alt="CleanSwipe"
        class="h-16 mb-6 object-contain drop-shadow-[0_0_25px_rgba(27,243,255,0.4)]"
      />



      <h1
        class="text-3xl sm:text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-white via-cyan-100 to-[#1BF3FF] mb-4 tracking-tight"
        style="font-family: 'Russo One', sans-serif"
      >
        UNDER MAINTENANCE
      </h1>

      <p class="text-gray-400 text-sm sm:text-base leading-relaxed mb-8">
        CleanSwipe is currently undergoing scheduled maintenance and updates.
        We will be back online shortly. Thank you for your patience!
      </p>


    </div>
  </div>

  <!-- Rendered view start -->
  <router-view v-else></router-view>
  <!-- Rendered view end -->
</template>

<script>
export default {
  computed: {
    isMaintenance() {
      return process.env.VUE_APP_MAINTENANCE_MODE === "true";
    },
  },
};
</script>

<style>
html {
  overflow-y: auto !important;
  overflow-x: auto !important;
  scroll-behavior: smooth;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateZ(0);
  }

  100% {
    opacity: 1;
    transform: translateZ(100%)
  }
}

.checkFade {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
}

.animated {
  -webkit-animation-duration: 0.6s;
  animation-duration: 0.6s;
}
</style>
